// src/utils/encryption.js
import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;      


export const encryptCardData = (cardData) => {
  try {
 
    const dataString = JSON.stringify(cardData);
    const encrypted = CryptoJS.AES.encrypt(dataString, ENCRYPTION_KEY);
    return encrypted.toString();
  } catch (error) {
    console.error('Encryption error:', error);
    throw new Error('Card encryption failed');
  }
};

export const encryptSensitiveData = (data) => {
  const sensitiveFields = ['cardNumber', 'cardExpireMonth', 'cardExpireYear', 'cardCvc'];
  const encryptedData = { ...data };
  
  // Hassas alanları şifrele
  sensitiveFields.forEach(field => {
    if (encryptedData[field]) {
      encryptedData[field] = CryptoJS.AES.encrypt(
        encryptedData[field].toString(),
        ENCRYPTION_KEY
      ).toString();
    }
  });

  return encryptedData;
};